import { useQuery, useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { message } from "antd";

import * as api from "apis/attendance";

export function useAttendances({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  return useQuery(
    ["attendances/pagination", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getAttendances(payload);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export function useAttendancesDaily({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  return useQuery(
    ["attendances/daily/pagination", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getAttendancesDaily(payload);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export function useAttendancesSummary({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  return useQuery(
    ["attendances/summary/pagination", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getAttendancesSummary(payload);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export const useEditAttendance = () => {
  return useMutation((payload) => api.editAttendance(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => {},
  });
};

export const useMassUpdateAttendances = () => {
  const { t } = useTranslation();
  return useMutation((payload) => api.massUpdateAttendances(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

// Query  upload import attendances
export const useUploadImportAttendances = () => {
  return useMutation((payload) => api.uploadImportAttendances(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => {},
  });
};

// Query  execute import attendances
export const useExecuteImportAttendances = () => {
  const { t } = useTranslation();
  return useMutation((payload) => api.executeImportAttendances(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};
